import { __exports as poller } from "../../../../../../../_virtual/poller2.js";
import { __require as requireLoglevel } from "../../types/loglevel.js";
import { __require as requireCohort } from "../../util/cohort.js";
import { __require as requireLogger } from "../../util/logger.js";
var hasRequiredPoller;
function requirePoller() {
  if (hasRequiredPoller) return poller;
  hasRequiredPoller = 1;
  var __awaiter = poller && poller.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  Object.defineProperty(poller, "__esModule", { value: true });
  poller.CohortPoller = void 0;
  const loglevel_1 = requireLoglevel();
  const cohort_1 = requireCohort();
  const logger_1 = requireLogger();
  class CohortPoller {
    constructor(fetcher, storage, flagCache, pollingIntervalMillis = 6e4, logLevel = loglevel_1.LogLevel.Error, loggerProvider = new logger_1.ConsoleLogger()) {
      this.fetcher = fetcher;
      this.storage = storage;
      this.flagCache = flagCache;
      this.pollingIntervalMillis = pollingIntervalMillis;
      this.logger = new logger_1.AmplitudeLogger(logLevel, loggerProvider);
    }
    /**
     * You must call this function to begin polling for cohort updates.
     *
     * Calling this function while the poller is already running does nothing.
     */
    start(onChange) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!this.poller) {
          this.logger.debug("[Experiment] cohort poller - start");
          this.poller = setInterval(() => __awaiter(this, void 0, void 0, function* () {
            try {
              yield this.update(onChange);
            } catch (e) {
              this.logger.debug("[Experiment] cohort update failed", e);
            }
          }), this.pollingIntervalMillis);
        }
      });
    }
    /**
     * Stop polling for cohorts.
     *
     * Calling this function while the poller is not running will do nothing.
     */
    stop() {
      if (this.poller) {
        this.logger.debug("[Experiment] cohort poller - stop");
        clearTimeout(this.poller);
        this.poller = void 0;
      }
    }
    update(onChange) {
      return __awaiter(this, void 0, void 0, function* () {
        let changed = false;
        const promises = [];
        const cohortIds = cohort_1.CohortUtils.extractCohortIds(yield this.flagCache.getAll());
        for (const cohortId of cohortIds) {
          this.logger.debug(`[Experiment] updating cohort ${cohortId}`);
          const existingCohort = this.storage.getCohort(cohortId);
          let lastModified = void 0;
          if (existingCohort) {
            lastModified = existingCohort.lastModified;
          }
          promises.push(this.fetcher.fetch(cohortId, lastModified).then((cohort) => {
            if (cohort) {
              this.storage.put(cohort);
              changed = true;
            }
          }).catch((err) => {
            this.logger.error("[Experiment] cohort poll failed", err);
          }));
        }
        yield Promise.all(promises);
        this.logger.debug(`[Experiment] cohort polled, changed: ${changed}`);
        if (onChange && changed) {
          yield onChange(this.storage);
        }
      });
    }
  }
  poller.CohortPoller = CohortPoller;
  return poller;
}
export {
  requirePoller as __require
};
//# sourceMappingURL=poller.js.map
